import React, { Component } from 'react'
import styled from 'styled-components'
import ArrowIcon from 'components/Svg/arrow.svg'
import { Button } from 'components/Counter'
import LessSvg from 'components/Counter/images/less.component.svg'
import PlusSvg from 'components/Counter/images/more.component.svg'
import Select from 'components/Select'
import findIndex from 'lodash/findIndex'
import { selectMapper } from 'utils'
import { connect } from 'kea'
import DataLogic from 'containers/App/logic'
//import { filter } from "lodash-es";

@connect({
  props: [DataLogic, ['values']],
})
export default class EquipmentsList extends Component {
  state = {
    opened: [],
    editingCarInfo: false,
  }

  setOpened = (item) => {
    const { opened } = this.state
    const found = findIndex(opened, ({ id }) => id === item.id)

    if (found !== -1) {
      opened.splice(found, 1)
    } else {
      opened.push(item)
    }

    this.setState({ opened })
  }

  /**
   * Sets the quantity of the opened
   */
  setOpenedQuantity = (item) => {
    const clone = { ...item }
    const { opened } = this.state
    const found = findIndex(opened, ({ id }) => id === clone.id)

    if (found !== -1) {
      if (!clone.quantity) {
        opened.splice(found, 1)
      } else {
        opened[found] = { ...clone }
      }
    }

    this.setState({ opened })
    this.props.onChange && this.props.onChange(clone)
  }

  componentWillReceiveProps(nextProps) {
    // Reset opened if division changed
    if (nextProps.division && this.props.division) {
      if (nextProps.division.id !== this.props.division.id) {
        this.setState({ opened: [] })
      }
    }
  }

  renderListItem = (item, index) => {
    const { data } = item

    const {
      allEquipments,
      division,
      onChangeEquipmentType,
      onChangeCarDetails,
      carChargingDurations,
      carChargingFrequencies,
      carChargingPowers,
    } = this.props
    let types
    let types2
    let hasMultipleTypes
    let hasMultipleTypes2

    const et = data.equipment_type.name === 'Iluminação'
    const cl = data.equipment_type.name === 'Climatização Local'
    const cc = data.equipment_type.name === 'Climatização Centralizada'
    const aqs = data.equipment_type.name === 'AQS'
    const fv = data.equipment_type.name === 'Funcionamento Variado'

    const isCar = item.svg_key === 'el-carro'
    /* eslint-disable camelcase */
    types = allEquipments
      .filter(
        ({ house_divisions, svg_key, id }) =>
          house_divisions.indexOf(division.id) !== -1 &&
          item.svg_key &&
          svg_key === item.svg_key
      )
      .map(selectMapper)

    types2 = allEquipments
      .filter((equipment) => equipment.equipment_type.name === 'Iluminação')
      .map(selectMapper)

    hasMultipleTypes2 = types2 && types2.length > 1

    /* eslint-enable camelcase */
    hasMultipleTypes = types && types.length > 1

    if (isCar) {
      return (
        <div>
          <EditItem>
            <Name>{`Quantas vezes carrega o seu veiculo eletrico?`}</Name>
            <TypeSelect
              margin
              placeholder={`Selecionar..`}
              items={carChargingFrequencies}
              arrowIcon={ArrowIcon}
              onChange={(frequency) =>
                onChangeCarDetails('frequency', frequency)
              }
              selected={
                this.props.values.carCharging &&
                this.props.values.carCharging.frequency
              }
              style={{ minWidth: '160px' }}
            />
          </EditItem>

          {!this.state.editingCarInfo && (
            <CarCharginInfo>
              <span>
                * Para efeitos de simulação serão considerados carregamentos
                efetuados em tomada domestica de 2,3kW com uma duração de 12h.
              </span>
              <a onClick={() => this.setState({ editingCarInfo: true })}>
                Alterar dados de carregamento
              </a>
            </CarCharginInfo>
          )}

          {this.state.editingCarInfo && (
            <div>
              <EditItem>
                <Name>{`Potência`}</Name>
                <TypeSelect
                  margin
                  placeholder={`Selecionar..`}
                  items={carChargingPowers}
                  arrowIcon={ArrowIcon}
                  onChange={(power) => onChangeCarDetails('power', power)}
                  selected={
                    this.props.values.carCharging &&
                    this.props.values.carCharging.power
                  }
                />
              </EditItem>
              <EditItem>
                <Name>{`Tempo de carregamento`}</Name>
                <TypeSelect
                  margin
                  placeholder={`Selecionar..`}
                  items={carChargingDurations}
                  arrowIcon={ArrowIcon}
                  onChange={(duration) =>
                    onChangeCarDetails('duration', duration)
                  }
                  selected={
                    this.props.values.carCharging &&
                    this.props.values.carCharging.duration
                  }
                />
              </EditItem>
            </div>
          )}
        </div>
      )
    }

    return (
      <ListItem key={`li-${index}`}>
        <ListItemHeader>
          {hasMultipleTypes2 && et && (
            <TypeSelect
              margin
              placeholder={`Iluminação`}
              items={types2}
              selected={data.id}
              render={(selected, placeholder) => placeholder}
              arrowIcon={ArrowIcon}
              onChange={(newType) => {
                onChangeEquipmentType(data, newType, item.svg_key)
              }}
            />
          )}

          {hasMultipleTypes && cl && (
            <TypeSelect
              margin
              placeholder={`Climatização Local`}
              items={types}
              selected={data.id}
              arrowIcon={ArrowIcon}
              onChange={(newType) =>
                onChangeEquipmentType(data, newType, item.svg_key)
              }
            />
          )}

          {hasMultipleTypes && cc && (
            <TypeSelect
              margin
              placeholder={`Climatização Centralizada`}
              items={types}
              selected={data.id}
              arrowIcon={ArrowIcon}
              onChange={(newType) =>
                onChangeEquipmentType(data, newType, item.svg_key)
              }
            />
          )}
          {hasMultipleTypes && aqs && (
            <TypeSelect
              margin
              placeholder={`AQS`}
              items={types}
              selected={data.id}
              arrowIcon={ArrowIcon}
              onChange={(newType) =>
                onChangeEquipmentType(data, newType, item.svg_key)
              }
            />
          )}
          {hasMultipleTypes && fv && (
            <TypeSelect
              margin
              placeholder={`Funcionamento Variado`}
              items={types}
              selected={data.id}
              arrowIcon={ArrowIcon}
              onChange={(newType) =>
                onChangeEquipmentType(data, newType, item.svg_key)
              }
            />
          )}
          {!hasMultipleTypes && !et && <Name>{data.name}</Name>}
          <Selector>
            <CounterButton
              less
              disabled={data.quantity === 0}
              onClick={() => {
                this.props.onChange({
                  ...item,
                  data: {
                    ...data,
                    quantity: !data.quantity ? 1 : data.quantity - 1,
                  },
                })
              }}>
              <LessSvg />
            </CounterButton>
            <Quantity>{data.quantity || 1}</Quantity>
            <CounterButton
              plus
              margin
              onClick={() => {
                this.props.onChange({
                  ...item,
                  data: {
                    ...data,
                    quantity: !data.quantity ? 1 : data.quantity + 1,
                  },
                })
              }}>
              <PlusSvg />
            </CounterButton>
          </Selector>
        </ListItemHeader>
      </ListItem>
    )
  }
  render() {
    const { equipments } = this.props
    return <List>{equipments && equipments.map(this.renderListItem)}</List>
  }
}

const CarCharginInfo = styled.div`
  text-align: left;
  padding: 10px;

  span {
    color: #666;
    text-align: left;
    display: block;
    margin-bottom: 10px;
  }

  a {
    color: green;
    text-decoration: underline;
    cursor: pointer;
  }
`

const List = styled.div`
  height: 350px;
  /*height: calc(100% - 6px);*/
  overflow: auto;
`

const ListItem = styled.div`
  box-shadow: inset 0 -1px 0 0 #efefef;
  text-align: left;
  cursor: pointer;
  position: relative;
  outline: none;
`

const Name = styled.span`
  color: #3e3e3e;
  font-size: 16px;
  font-weight: bold;
  line-height: 17px;
  display: inline-block;
  margin-right: 20px;
`

const EditItem = styled.div`
  box-shadow: inset 0 -1px 0 0 #efefef;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 10px;
`

const CounterButton = styled(Button)`
  width: 30px;
  height: 30px;
  display: inline-block;
  vertical-align: middle;
  float: none;
  margin: 0;

  svg {
    margin: 0;
    height: 12px;
    width: 12px;
  }
`

const Selector = styled.div`
  margin-right: 10px;
`

const Quantity = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin: 0 10px;
  font-weight: bold;
`

const ListItemHeader = styled.div`
  padding: 10px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${({ hasInside }) =>
    hasInside &&
    `
    padding-right: 35px;
    &:after {
      content: "";
      display: block;
      background: url(${ArrowIcon});
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 12px;
      height: 12px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 10px;
    }
  `}
  ${({ opened }) =>
    opened &&
    `
  &:after {
    transform: rotate(180deg)translateY(50%);
  }
`}
`

const TypeSelect = styled(Select)`
  width: 100%;
  flex: 1;
  min-width: 160px;
  > div {
    padding: 0;
    border: 0;
    color: #3e3e3e;
    font-size: 16px;
    font-weight: bold;
    line-height: 17px;
  }
  > div:last-child {
    position: absolute;
    max-width: auto;
  }
`



// WEBPACK FOOTER //
// ./src/containers/EquipmentsListSimple/index.js